import { createSlice } from '@reduxjs/toolkit'
import { storeApi, courseApi, coursePackageApi } from '../../utils/urls';
import { nanoid } from '@reduxjs/toolkit'
import { STATUS_FAILED, STATUS_LOADING, STATUS_SUCCEEDED, TOAST_ERROR, TOAST_SUCCESS } from '../../utils/constants';
import { enqueueSnackbar } from 'notistack'
import httpClient from '../../services/httpClient';
import { viewItemGa } from '../../helpers/GATracker';
import i18next from "i18next";
import { createDedupedAsyncThunk } from '../../utils/thunkUtils';

// ----------------- Thunks -----------------------------

//WHEN SAVING LAYOUT:  we need to make sure we dont delete any other data that it is inside settings

export const fetchCourse = createDedupedAsyncThunk('course/fetchCourse', async ({ storeName, slugName, type }, { getState, dispatch, rejectWithValue }) => {

  const body = {
    data: {
      slug: slugName,
      type,
      toc: 1,
      username: storeName
    },
    method: 'findBySlug'
  };

  const res = await httpClient.post(storeApi(), body, { getState, dispatch, rejectWithValue, noToken:true });

  return res.data;
})

export const fetchCourseById = createDedupedAsyncThunk('course/fetchCourseById', async ({ courseId, isPackage }, { getState, dispatch, rejectWithValue }) => {

  const body = {
    data: {
      id: courseId,
      type: isPackage ? 2 : 1
    },
    method: 'findById'
  };

  const res = await httpClient.post(storeApi(), body, { getState, dispatch, rejectWithValue });
  return res.data;
})

export const toggleCourseVisibility = createDedupedAsyncThunk('course/toggleVisibility', async ({ courseId, isPackage }, { getState, dispatch, rejectWithValue }) => {

  const body = {
    data: {
      id: courseId
    },
    method: 'toggleVisibility'
  };

  const url = !isPackage ? courseApi() : coursePackageApi();

  const res = await httpClient.post(url, body, { getState, dispatch, rejectWithValue });

  const message = res.isError ? res.errMsg : i18next.t('webshop.build.toggleVisibility')
  const variant = res.isError ? TOAST_ERROR : TOAST_SUCCESS
  enqueueSnackbar(message, { variant })

  return res.data;
});

export const createCoursePackage = createDedupedAsyncThunk('course/createCoursePackage', async ({ newData }, { getState, dispatch, rejectWithValue }) => {

  const body = {
    data: newData,
    method: 'create'
  };

  const res = await httpClient.post(coursePackageApi(), body, { getState, dispatch, rejectWithValue });

  const message = res.isError ? res.errMsg : i18next.t('webshop.build.createdPackageSuccess')
  const variant = res.isError ? TOAST_ERROR : TOAST_SUCCESS
  enqueueSnackbar(message, { variant })

  return res.data
})
export const clearCoursePackageSequence = createDedupedAsyncThunk('course/clearCoursePackageSequence', async ({ id }, { getState, dispatch, rejectWithValue }) => {

  const body = {
    data: { id },
    method: 'clearSequence'
  };

  const res = await httpClient.post(coursePackageApi(), body, { getState, dispatch, rejectWithValue });
  return res.data
})

export const saveCourse = createDedupedAsyncThunk('course/saveCourse', async ({ newData, isPackage }, { getState, dispatch, rejectWithValue }) => {
  const body = {
    data: newData,
    method: 'update'
  };
  const url = !isPackage ? courseApi() : coursePackageApi();
  const res = await httpClient.post(url, body, { getState, dispatch, rejectWithValue });

  const message = res.isError ? res.errMsg : i18next.t('webshop.build.settingsSaved')
  const variant = res.isError ? TOAST_ERROR : TOAST_SUCCESS
  enqueueSnackbar(message, { variant })

  return res.data
})

export const deleteCoursePackage = createDedupedAsyncThunk('course/deleteCoursePackage', async (id, { getState, dispatch, rejectWithValue }) => {

  const body = {
    data: { id },
    method: 'delete'
  };

  const res = await httpClient.post(coursePackageApi(), body, { getState, dispatch, rejectWithValue });

  const message = res.isError ? res.errMsg : i18next.t('webshop.build.deletedPackageSuccess')
  const variant = res.isError ? TOAST_ERROR : TOAST_SUCCESS
  enqueueSnackbar(message, { variant })

  return res.data;
});

// ----------------- Reducers ---------------------------

const mockId = (data) => data?.map(el => { return { ...el, id: nanoid() } });

const initialState = {
  id: null,
  status: 'idle', // or: 'loading', 'succeeded', 'failed'

  name: '',
  teacher: {}, //name:'', about:'', avatarUrl:''},
  highlightedInfo: {}, //title:'', text:'', image:{id:'', url:''}},
  coverMedia: { video: { id: null, url: null }, image: { id: null, url: null } },//video:{id:'', url:''}, image:{id:'', url:''}}, //image is not editable only when creating course
  ctaBanner:{}, //title:'', descrition:''
  introduction: {},//title: '' }, Title is not editable only when creating course
  infoIcons: [],//{iconName:'', title:'', text:'', id:''}],
  infoPoints: [],//{title:'', text:'', id:''}],
  courseContent: {}, //do not present raw toc but allow to edit the toc to set proper description
  courseToc: {},
  customFile: {}, // {id: '', url: '', name: ''}
  sectionTitles: {},
  categories: [],
  packageItems: [],
  hideToc: false,

  price: {},//{gross:'', net:'', discounted:''}
  ucpPeriod: 2592000,
  currency: 'SEK',
  isPublic: 0,
  hasSequence: null,
  sequence: null,

  dontDeleteSettings: {},

  testimonies: [],//{image:'', name:'', text:''}]
  cta: ''
  // emailGatherer:'',

}

const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(toggleCourseVisibility.pending, (state, action) => {
        state.status = STATUS_LOADING;
      })
      .addCase(toggleCourseVisibility.fulfilled, (state, action) => {
        state.status = STATUS_SUCCEEDED;
        state.data = { ...state.data, ...action.payload };
      })
      .addCase(fetchCourse.pending, (state, action) => {
        return { ...initialState, status: STATUS_LOADING };
        // state.status = STATUS_LOADING;
      })
      .addCase(fetchCourse.rejected, (state, action) => {
        state.status = STATUS_FAILED
      })
      .addCase(fetchCourse.fulfilled, (state, action) => {
        if (!action.payload) {
          state.status = STATUS_FAILED
          return;
        }

        const payload = action.payload;
        
        // Track GA event
        viewItemGa({
          id: payload.id,
          name: payload.name,
          price: payload.price?.discounted,
          quantity: 1
        });

        // Set basic course info
        state.id = payload.id;
        state.status = STATUS_SUCCEEDED;
        
        const {coverImage, currency, name, type, courses, categories, description, settings} = payload;
        const isBundle = type === 2;
        state.name = name ?? state.name;
        const hasSequenceDefined = Object.prototype.hasOwnProperty.call(payload, 'hasSequence');
        state.hasSequence = isBundle ? (hasSequenceDefined ? Boolean(payload.hasSequence) : null) : null;
        state.sequence = isBundle ? (Array.isArray(payload.sequence) ? payload.sequence : null) : null;

        let parsedSettings = null;
        if (!isBundle && settings) {
          if (typeof settings === 'string') {
            parsedSettings = settings.length ? JSON.parse(settings) : null;
          } else if (typeof settings === 'object') {
            parsedSettings = settings;
          }
        }

        let layoutFromSettings = null;
        state.dontDeleteSettings = {};

        if (!isBundle && parsedSettings && typeof parsedSettings === 'object') {
          const { layout, ...restSettings } = parsedSettings;
          layoutFromSettings = layout;
          if (Object.keys(restSettings).length) {
            state.dontDeleteSettings = restSettings;
          }
        }

        // Handle basic properties with nullish coalescing
        if (categories && categories.length) {
          const normalizedCategories = categories.map(category =>
            typeof category === 'string' ? category : category?.slug
          ).filter(Boolean);
          state.categories = normalizedCategories;
        } else {
          state.categories = [];
        }
        state.introduction = name ? {...state.introduction, title: name} : state.introduction;
        
        // Handle cover image
        if (coverImage?.[0]) {
          state.coverMedia = { image: coverImage[0] };
        }
        
        // Handle course TOC for non-bundle courses
        if (!isBundle && courses?.length) {
          state.courseToc = courses[0].toc;
        }

        // Handle bundle layout
        if (isBundle && courses?.length) {
          state.packageItems = courses.map((item) => {
            const settingsData = item.config;
            let newCourseLayout = {};
            
            if (settingsData?.layout && Object.keys(settingsData.layout).length) {
              const { teacher, highlightedInfo, infoIcons, infoPoints, 
                     testimonies, introduction, customFile } = settingsData.layout;
                     
              newCourseLayout = {
                teacher,
                highlightedInfo,
                infoIcons: mockId(infoIcons),
                infoPoints: mockId(infoPoints),
                testimonies,
                introduction,
                customFile
              };
            }
            
            newCourseLayout.courseContent = item.toc;
            
            return {
              ...item, 
              settings: {...settingsData, layout: newCourseLayout}
            };
          });
        } else if (!isBundle) {
          state.packageItems = [];
        }

        // Handle additional media and settings
        if (payload.videoUrl) {
          state.coverMedia = { ...state.coverMedia, video: { url: payload.videoUrl } };
        }
        
        if (payload.price) state.price = payload.price;
        if (payload.ucpPeriod) state.ucpPeriod = payload.ucpPeriod;
        if (payload.public !== undefined) state.isPublic = payload.public;

        // Process layout data
        const data = isBundle ? 
          payload.layout : 
          layoutFromSettings;

        if (data) {
          const { 
            teacher, highlightedInfo, infoIcons, infoPoints, hideToc,
            testimonies, courseCoverMedia, ctaBanner, sectionTitles, customFile 
          } = data;

          // Apply layout properties
          state.coverMedia = Array.isArray(courseCoverMedia) ? { video: {}, image: {} } : courseCoverMedia;
          state.teacher = teacher ?? state.teacher;
          state.highlightedInfo = highlightedInfo ?? state.highlightedInfo;
          state.infoIcons = infoIcons ? mockId(infoIcons) : [];
          state.infoPoints = infoPoints ? mockId(infoPoints) : [];
          state.courseContent = state.courseToc;
          state.testimonies = testimonies ?? state.testimonies;
          state.sectionTitles = sectionTitles ?? state.sectionTitles;
          state.ctaBanner = ctaBanner ?? state.ctaBanner;
          state.hideToc = hideToc ?? state.hideToc;
          state.customFile = customFile ?? state.customFile;
        }
      })
      .addCase(saveCourse.pending, (state, action) => {
        state.status = STATUS_LOADING;
      })
      .addCase(saveCourse.rejected, (state, action) => {
        state.status = STATUS_FAILED
      })
      .addCase(saveCourse.fulfilled, (state, action) => {
        state.status = STATUS_SUCCEEDED
        state.course = action.payload;
      })
  }
})

export default courseSlice.reducer

// ----------------- Selectors --------------------------
export const selectCourseCoverMedia = state => state.webshop.course.coverMedia;
export const selectCtaBanner = state => state.webshop.course.ctaBanner
export const selectLayout = state => state.webshop.course;
export const selectCourseIsPublic = state => state.webshop.course.isPublic;
export const selectLayoutId = state => state.webshop.course.id;
export const selectStatus = state => state.webshop.course.status;

